<template>
    <form-row title="Water" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_water"
                v-model="has_water"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_water" class="pt-6 pb-2">
                <div class="flex">
                    <input-money
                        class="mr-6"
                        label="Cost"
                        placeholder="Cost"
                        name="water_cost"
                        v-model="water_cost"
                        :read_only="read_only"
                    />

                    <input-text
                        class="mr-6"
                        label="Building sq.ft."
                        v-model="square_feet"
                        :read_only="true"
                    />

                    <input-money
                        label="Cost/sq.ft."
                        :value="cost_per_square_foot"
                        :read_only="true"
                    />
                </div>

                <input-text
                    class="w-full pt-3"
                    label="Contract company"
                    placeholder="Company name"
                    name="water_company"
                    :value="commercial.water_company"
                    :read_only="read_only"
                />

                <input-textarea
                    class="w-full pt-3"
                    placeholder="Contact information"
                    name="water_company_contact_info"
                    :value="commercial.water_company_contact_info"
                    :rows="3"
                    :read_only="read_only"
                />

                <div class="border-t border-gray-400 mt-8 py-6">
                    <input-text
                        label="Where is it located now?"
                        class="w-full"
                        name="utilities_water"
                        :value="commercial.utilities_water"
                        :read_only="read_only"
                    />

                    <buyer-seller-city
                        label="Who is Responsible for bringing it to the Property Line?"
                        class="mt-5"
                        field="utilities_water_who_responsible"
                        :value="commercial.utilities_water_who_responsible"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import BuyerSellerCity from '../buyer-seller-city.vue';
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        BuyerSellerCity,
    },

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_water: this.commercial.has_water,
            water_cost: this.commercial.water_cost,
        }
    },

    computed: {
        square_feet: {
            get() {
                return store.state.square_feet || null;
            },
            set(val) {
                store.state.square_feet = val;
            },
        },
        cost_per_square_foot() {
            return this.water_cost && this.square_feet
                ? Math.round(this.formatMoney(this.water_cost) / parseInt(this.square_feet) * 100) / 100
                : null;
        },
    },
}
</script>
